import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  LeftOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  WifiOutlined,
  PayCircleOutlined,
  RightOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  VerticalAlignBottomOutlined,
} from '@ant-design/icons';

import {
  Typography,
  Slider,
  Table,
  Modal,
  Popconfirm,
  message,
  Image,
  Input,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _cardbg from '../../assets/card.png';
import _whitelogo from '../../assets/logo-non-color.png';
import api from '../../api';
import useNotification from '../../hooks/useNotification';
import * as actions from '../../redux/actions/auth';
import connectCSKH from '../../utils/connectCSKH';
import CurrencyInput from 'react-currency-input-field';
import walletImage from '../../assets/list-bank.png';
import './Wallet.scss';
import moment from 'moment';
import _ from 'lodash'
export default function Wallet() {
  const { cskh } = useSelector((state) => state._content);
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const { profile } = useSelector((state) => state._auth);
  const { notifications, pushNotifications } = useNotification();
  const history = useHistory();
  const dispatch = useDispatch();
  const [currentRequest, setCurrentRequest] = useState({});
  const [OTP, setOTP] = useState('');
  const [visibleOTP, setVisibleOTP] = useState(false);
  useEffect(() => {
    // (async () => {
    //   const { data } = await api.get('/users/profile');
    //   dispatch(actions.initialLogin(data.data));
    //   loadCurrentRequest()
    // })();
    loadProfile()
  }, [notifications]);

  const loadProfile = async () => {
    const { data } = await api.get('/users/profile');
    dispatch(actions.initialLogin(data.data));
    loadCurrentRequest()
  }

  const loadCurrentRequest = async () => {
    try {
      const { data } = await api.get('/requests/lasted');
      setCurrentRequest(data?.data ? data.data : {})
    } catch (error) {
      setCurrentRequest({})
      console.log(error);
    }
  }

  const [contract, setContract] = useState({});
  const [visible, setVisible] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const onConfirmWithdraw = async (e) => {
    if (!currentRequest) {
      message.error('요청 정보 검색에 실패했습니다. 나중에 다시 시도해 주세요!');
      return;
    }

    if (profile.balance === 0) {
      message.error('사용 가능한 잔액이 부족합니다.');
      return;
    }

    const contracts = await api.get('/contracts');

    if (contracts.data.data[0]) {
      // requestResult = contract
      const requestResult = await api.post('/requests', {
        amount: e,
        contractId: contracts.data.data[0]._id,
        bank_reciever: {
          name: profile?.kyc?.bank.name,
          number: profile?.kyc?.bank.number,
          bankName: profile?.kyc?.bank.bankName,
        },
      });
      setContract(requestResult.data)

      pushNotifications({
        message: `${profile.phone} 출금을 요청하다`,
        description: `고객이 출금 요청을 작성 중입니다: ${e.toLocaleString()}`,
      });
      loadProfile()
      setVisible(true);
      setIsDone(requestResult.data.response === 'accepted')
      return requestResult;
    } else {
      message.error('아직 대출계약이 없으신 분은 먼저 대출신청을 등록하고 완료해주세요!');
      return;
    }
  };

  const onClickVerify = async (e) => {
    try {
      const contracts = await api.get('/contracts');
      setContract(contracts.data.data[0]);
      const requestResult = await api.post('/requests/verify', {
        id: currentRequest._id,
        error: contracts?.data?.data[0].response || '',
        otp: OTP,
        status: contracts.data.data[0].response === 'accepted' ? 'accepted' : 'rejected'
      });

      loadProfile()
      setOTP('')
      // setVisible(contracts.data.data[0].response !== 'accepted');
      setIsDone(contracts.data.data[0].response === 'accepted')
      setVisible(true)
    } catch (error) {
      console.log(error);
    }
  };

  const [isConfirm, setIsConfirm] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0.3, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="header-container">
        <div />
        <Typography.Text
          strong
          style={{ fontWeight: 700, fontSize: 18, color: '#fff' }}
        >
          지갑
        </Typography.Text>
        <div></div>
      </div>
      <div style={{ padding: 10 }}>
        <Card
          data={profile}
          balance={profile?.balance}
          onWithdraw={(e) => onConfirmWithdraw(e)}
          currentRequest={currentRequest}
          setVisibleOTP={setVisibleOTP}
        />
        <motion.div whileTap={{ scale: 0.97, opacity: 0.3 }}>
          <Item
            text="연결된 계좌로 돈을 인출하세요"
            icon={<PayCircleOutlined className="pay-circle" />}
            onClick={
              profile?.kyc?.status
                ? () => onConfirmWithdraw(profile?.balance)
                : () => message.info('먼저 본인 인증을 하셔야 합니다.')
            }
          />
        </motion.div>
        {
          !_.isEmpty(currentRequest) &&
          <div className='request-detail'>
            <div className="title-detail">지급 세부정보</div>
            <table>
              <tr>
                <td>출금시간</td>
                <td>{moment(currentRequest.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
              </tr>
              <tr>
                <td>계좌로 실제 출금</td>
                <td>{currentRequest.amount ? currentRequest.amount.toLocaleString() + '원' : ''}</td>
              </tr>
              <tr>
                <td>출금현황</td>
                <td>{renderStatus(currentRequest.status)}</td>
              </tr>
              <tr>
                <td>메모</td>
                <td>{currentRequest.error}</td>
              </tr>
            </table>
          </div>
        }

        <Image
          src={walletImage}
          style={{ padding: 5, borderRadius: 10 }}
          preview={false}
        />
      </div>
      <Modal
        visible={visible}
        title={null}
        footer={null}
        closable={true}
        onCancel={() => {
          setVisible(false);
          setIsConfirm(false);
        }}
        destroyOnClose
      >
        <div className="verifying">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            {isDone ? (
              <>
                <CheckOutlined style={{ color: '#40eb31', fontSize: 40 }} />
                <Typography.Text
                  style={{
                    color: '#333',
                    fontSize: 19,
                    textAlign: 'center',
                    paddingVertical: 10,
                  }}
                >
                  성공적으로 돈을 인출하세요!
                </Typography.Text>
                <Typography.Text
                  style={{ color: '#777', fontSize: 15, textAlign: 'center' }}
                >
                  계좌이체 주문이 완료되었습니다. 계좌번호로 돈이 들어올 때까지 기다려주세요
                  연결되었습니다! 예상시간은 30분!
                </Typography.Text>
              </>
            ) : (
              <>
                {contract?.response ==
                  'accepted' ? (
                  <>
                    <CheckCircleOutlined
                      style={{ fontSize: 50, color: 'green' }}
                    />
                    <Typography.Text
                      style={{
                        color: '#777',
                        fontSize: 17,
                        color: 'green',
                        textAlign: 'center',
                        padding: 10,
                      }}
                    >
                      {contract.status == 'pending'
                        ? '검토중'
                        : contract?.response}
                    </Typography.Text>
                  </>
                ) : (
                  <>
                    <ExclamationCircleOutlined
                      style={{ fontSize: 50, color: '#eb314a' }}
                    />
                    <Typography.Text style={{ color: '#777', fontSize: 17 }}>
                      요청을 거부하세요
                    </Typography.Text>
                    <Typography.Text
                      style={{ color: '#777', fontSize: 17, color: '#eb314a' }}
                    >
                      {contract.status == 'pending'
                        ? '검토중'
                        : contract?.response}
                    </Typography.Text>
                  </>
                )}

                <Typography.Text style={{ color: '#777', fontSize: 17 }}>
                  지원을 받으려면 온라인 고객 서비스에 문의하세요.
                </Typography.Text>
                <br />

                <motion.div
                  whileTap={{ opacity: 0.4, scale: 0.97 }}
                  style={{
                    background: '#002dbf',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 10,
                    padding: 5,
                  }}
                  onClick={() => connectCSKH(profile)}
                >
                  <Typography.Text
                    style={{ fontSize: 17, color: '#fff', fontWeight: 'bold' }}
                  >
                    고객 서비스에 문의하려면 여기를 클릭하세요.
                  </Typography.Text>
                </motion.div>
              </>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        visible={visibleOTP}
        title={'OTP'}
        footer={null}
        closable={true}
        onCancel={() => setVisibleOTP(false)}
        destroyOnClose
      >
        <div className="withdraw-money-container">
          <Input
            className="input-currency"
            placeholder="OTP 코드를 입력하세요"
            value={OTP}
            onChange={(e) => setOTP(e.target.value)}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <motion.div
              whileTap={{ opacity: 0.4, scale: 0.97 }}
              className="check-amount"
              onClick={() => {
                setVisibleOTP(false);
                onClickVerify();
              }}
            >
              <Typography.Text
                style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}
              >
                계속
              </Typography.Text>
            </motion.div>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
}

function Card({ data, balance, onWithdraw, currentRequest, setVisibleOTP }) {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [amount, setAmount] = useState(0);
  const [showMoney, setShowMoney] = useState(true);
  const [showBankAccount, setShowBankAccount] = useState(false);
  return (
    <motion.div
      style={{ padding: 5 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            borderRadius: 5,
            width: '100%',
            height: 200,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'column',
            backgroundImage: `url(${_cardbg})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <div className="card-head-img">
            <div style={{}}>
              {data?.kyc?.bank?.logo ? (
                data?.kyc?.bank?.logo != 'undefined' ?
                (<Image
                  src={data?.kyc?.bank?.logo}
                  width="50%"
                  preview={false}
                />) : (<Typography.Text
                  style={{ fontSize: 20, color: '#fff', padding: '0px 5px' }}
                >
                  {data?.kyc?.bank?.bankName ? data?.kyc?.bank?.bankName : ''}
                </Typography.Text>)
              ) : (
                <WifiOutlined
                  style={{
                    fontSize: 26,
                    color: '#fff',
                    fontWeight: 'bold',
                    transform: 'rotate(90deg)',
                  }}
                />
              )}
            </div>
          </div>
          <div
            style={{
              padding: 10,
              justifyContent: 'flex-start',
              minWidth: '100%',
            }}
          >
            <div className="atm-card-information" style={{ position: 'relative' }}>
              {data?.kyc?.bank?.number ? (
                <>
                  <div style={{ position: 'absolute', top: 0, right: '10px' }}>
                    {showBankAccount ? (
                      <EyeOutlined
                        onClick={() => setShowBankAccount((prev) => !prev)}
                        className="eye-icon"
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        onClick={() => setShowBankAccount((prev) => !prev)}
                        className="eye-icon"
                      />
                    )}
                  </div>

                  <Typography.Text className="atm-card-text" >
                    {data?.kyc?.bank?.number
                      ?
                      showBankAccount ? `${data.kyc.bank.number}` : `********` + data.kyc.bank.number.substring(data.kyc.bank.number.length - 4)
                      : ''}
                  </Typography.Text>
                  <Typography.Text className="atm-card-text">
                    {data?.kyc?.bank?.name}
                  </Typography.Text>
                </>
              ) : (
                <Typography.Text className="atm-card-text">
                  아직 등록되지 않았습니다
                </Typography.Text>
              )}
            </div>
          </div>
        </div>
      </div>
      <motion.div
        className="check-amount-container"
        onClick={() => {
          // console.log('onClick', currentRequest);
          // if (currentRequest && currentRequest.status === 'pending') {
          //   setVisibleOTP(true)
          //   return
          // }
          setVisible(true)
        }}
      >
        <motion.div style={{}} whileTap={{ opacity: 0.3 }}>
          <Typography.Text
            style={{ fontSize: 15, color: '#333', fontWeight: '600' }}
          >
            지갑 잔액:
          </Typography.Text>
          <br />
          <div />
        </motion.div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          {showMoney ? (
            <EyeOutlined
              onClick={(e) => {e.stopPropagation(); setShowMoney((prev) => !prev)}}
              className="eye-icon"
            />
          ) : (
            <EyeInvisibleOutlined
              onClick={(e) => {e.stopPropagation(); setShowMoney((prev) => !prev)}}
              className="eye-icon"
            />
          )}
          <br />
          <Typography.Text
            style={{ fontSize: 17, color: '#CE4F53', fontWeight: 700 }}
          >
            {showMoney ? `${data?.balance?.toLocaleString()}원` : '******'}{' '}
          </Typography.Text>
        </div>
      </motion.div>
      <a
        onClick={() => history.push('/history')}
        style={{ textDecoration: 'underline', margin: 5 }}
      >
        잔액 변동
      </a>
      <Modal
        visible={visible}
        title={'출금'}
        footer={null}
        closable={true}
        onCancel={() => setVisible(false)}
        destroyOnClose
      >
        <div className="withdraw-money-container">
          <CurrencyInput
            className="input-currency"
            min={0}
            max={balance}
            placeholder="인출금액을 입력하세요"
            decimalsLimit={2}
            onValueChange={(value, name) => setAmount(parseInt(value))}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <motion.div
              whileTap={{ opacity: 0.4, scale: 0.97 }}
              className="check-amount"
              onClick={() => {
                if (amount > data?.balance) {
                  message.info('사용 가능한 레벨보다 높을 수 없습니다');
                  return;
                }

                setVisible(false);
                onWithdraw(amount);
              }}
            >
              <Typography.Text
                style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}
              >
                계속
              </Typography.Text>
            </motion.div>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
}
const Item = ({ text = 'title', icon, onClick = () => { } }) => {
  return (
    <div className="item" onClick={onClick}>
      <Typography.Text
        style={{ flex: 1, fontSize: 16, paddingLeft: 20, color: '#fff' }}
        strong
      >
        {text}
      </Typography.Text>
      <VerticalAlignBottomOutlined style={{ color: '#fff', fontSize: 30 }} />
    </div>
  );
};

const renderStatus = (status) => {
  switch (status) {
    case 'pending':
      return '검토중'
    case 'accepted':
      return '성공'
    case 'rejected':
      return '거부됨'
  }
  return ''
}
